module.exports = __webpack_public_path__ + "static/media/lauren2.e14ae6cd.jpg";